<template>
    <span v-show="unit" class="amount-unit-tip">{{ unit }}</span>
</template>

<script>
// 金额单位提示气泡：根据金额自动换算展示 千/万/十万/百万/千万/亿/十亿/百亿/千亿
// 小于 1000 或非法值时隐藏，不占位。
export default {
    name: "AmountUnitTip",
    props: {
        value: {
            type: [Number, String],
            default: ""
        }
    },
    computed: {
        unit() {
            const str = String(this.value || "").trim();
            if (!/^\d+(\.\d+)?$/.test(str)) return "";
            const numValue = Number(str);
            if (!numValue || isNaN(numValue) || numValue < 1000) return "";
            const units = [
                { value: 1e11, label: "千亿" },
                { value: 1e10, label: "百亿" },
                { value: 1e9, label: "十亿" },
                { value: 1e8, label: "亿" },
                { value: 1e7, label: "千万" },
                { value: 1e6, label: "百万" },
                { value: 1e5, label: "十万" },
                { value: 1e4, label: "万" },
                { value: 1e3, label: "千" }
            ];
            for (const u of units) {
                if (numValue >= u.value) return u.label;
            }
            return "";
        }
    }
};
</script>

<style lang="scss" scoped>
.amount-unit-tip {
    position: absolute;
    top: -20px;
    left: 14px;
    z-index: 2;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;
    background: var(--color-primary);
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
    user-select: none;
    pointer-events: none;
    &::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: -3px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid var(--color-primary);
    }
}
</style>
